import config from '@plone/volto/registry';

interface RecordLike {
  title?: string;
  name?: string;
  abstract?: string;
  description?: string;
}

export function buildDatasetJsonLd(record: RecordLike): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'Dataset',
    name: record.title || record.name || '',
    description: record.abstract || record.description || '',
  };
}

export function buildAppJsonLd(): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'NSDI Search',
    description:
      'Search and discover National Spatial Data Infrastructure datasets',
    // config.settings.publicURL is driven by RAZZLE_PUBLIC_URL (already set per environment)
    url: (config.settings as any).publicURL,
    applicationCategory: 'GovernmentApplication',
    provider: {
      '@type': 'Organization',
      name: 'Federal Geographic Data Committee (FGDC)',
    },
  };
}
